import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import backgroundCircle from '@assets/images/circles.png';

import {
  Box,
  Button,
  FormControl,
  Grid,
  InputAdornment,
  OutlinedInput,
  Toolbar,
  Typography,
  Collapse,
  Container,
} from '@mui/material';
import { usePolicyStore } from '@store/policyStore';
import { useTokenStore } from '@store/TokenStore';
import { useIdStore } from '@store/UrlIdStore';
import { useHistory } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import PolicyListSlider, { PolicyListSlideItem } from '@screens/customerPortal/policyListSlider/PolicyListSlider';
import Coppel from '@assets/images/Coppel.png';
import Asesor from '@assets/images/Asesor.svg';
import Club from '@assets/images/club_de_proteccion.svg';
import { getToken } from '@api/getToken';
import { InterInstance } from '@api/config';
import { useAsociadoStore } from '@store/useAsociadoStore';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { ModalHelp } from '@modals/ModalNeedHelp/ModalHelp';
import { ZustandContext } from '@store/modalStore';
import { LimitReachedModal } from '@modals/LimitReachedModal';
import { AlertTitle } from '@mui/lab';


const useStyles = makeStyles({
  root: {
    paddingBottom: '40px',
    /* backgroundImage: `url(${backgroundCircle})`,*/
    backgroundSize: '20%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right',
    backgroundPositionY: '35%'
  }
});

export const CustomerPortal: React.FC = () => {
  const { token } = useTokenStore();
  const [loading, setLoading] = useState(true);
  const [employee,setEmployee]= useState<any>(null)
  const [policiesData, setPoliciesData] = useState<PolicyListSlideItem[]>([]);
  const [open, setOpen] = useState(true);

  const classes = useStyles();
  const history = useHistory();
  const { policy,addPolicyInfo,removePolicyInfo } = usePolicyStore();
  const { id,setId } = useIdStore();
  const { marcarVerificado } = useAsociadoStore();
  const { show, hide } = React.useContext(ZustandContext);

  const getPolicies = async (id: string) => {
    setLoading(true);
    let tmpToken = token;
    if (!tmpToken) {
      tmpToken = await getToken();
    }
    const { data } = await InterInstance({
      method: 'GET',
      url: `/catalogs/coppel-workers/${id}/policies`,
      headers: { Authorization: `Bearer ${tmpToken}` }
    }).catch(error => {
      console.log(error);
      return error;
    });

    if (data && data.success) {
      const { data: { policies } } = data;
      setPoliciesData(policies);
    } else {
      setPoliciesData([]);
    }
    setLoading(false);
  };


  useEffect(() => {
    if (id) {
     // console.log('id===>>', id)
      setEmployee({ id: id, ...policy.employee_obj });
      getPolicies(id);
    }
    let numColaborador = policy.employee_obj.numeroempleado
      ? policy.employee_obj.numeroempleado
      : policy.employee_obj?.NumeroColaborador ;
    if (numColaborador === '') {
      history.push('/');
    }
  }, [id]);

  const newQuote = () => {
    let numColaborador = policy.employee_obj.numeroempleado
      ? policy.employee_obj.numeroempleado
      : policy.employee_obj?.NumeroColaborador;

    marcarVerificado(true);

   // sessionStorage.clear();
   // removePolicyInfo();
    addPolicyInfo({
      ...policy,
      employee_id: numColaborador + '',
    });
    setId(numColaborador + '');
    history.push('/home');
  };

  const getNameAction =() =>{
    let name = policy?.employee_obj?.nombreempleado ?
      policy?.employee_obj?.nombreempleado +
        ' ' +
        policy?.employee_obj?.apellidopaternoempleado +
        ' ' +
        policy?.employee_obj?.apellidomaternoempleado: policy.employee_obj.correo
    return name
  }

  const handleLimitReached = () => {
    show(LimitReachedModal, { onClose: hide });

  };
  useEffect(() => {
    if (policiesData.length === 10) {
      handleLimitReached();
    }
  }, [policiesData.length]);
  return (
    <div className={classes.root}>
      <Toolbar
        variant="dense"
        disableGutters
        sx={{ height: { xs: '140px', md: '120px' } }}
      />
      <Box>
        <Container maxWidth="lg">
          <Box sx={{ mb: 4, mt: 2 }}>
            {/* Usamos el color 'info' (azul claro) que da tranquilidad, no 'warning' o 'error' */}
            <Alert severity="info" sx={{ borderRadius: 2 }}>
              <AlertTitle>
                <strong>
                  Estamos mejorando tu experiencia y optimizando la
                  visualización de tu información.
                </strong>
              </AlertTitle>
              <Typography variant="body2">
                Durante este proceso, es posible que algunas pólizas no sean
                visibles temporalmente. Muy pronto podrás consultarlas todas en
                un solo lugar.
              </Typography>
            </Alert>
          </Box>
        </Container>
      </Box>
      <Box
        sx={{ height: 'auto', padding: 2, maxWidth: '1140px', margin: 'auto' }}
      >
        <Stack spacing={2} direction={{ xs: 'column', md: 'row' }}>
          <Box sx={{ width: { xs: '100%', md: '461px' }, height: '550px' }}>
            <Grid>
              <Box sx={{ position: 'relative' }}>
                <Box
                  sx={{
                    position: 'absolute',
                    display: 'flex',
                    flexDirection: 'column',
                    width: '275px',
                    top: '270px',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      textAlign: 'center',
                      justifyContent: 'center',
                      gap: 2,
                      padding: '16px 16px 0 16px',
                    }}
                  >
                    <Typography
                      style={{
                        color: 'var(--White, #FFF)',
                        fontSize: '20px',
                        textAlign: 'left',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        lineHeight: 'normal',
                        letterSpacing: '-0.36px',
                      }}
                    >
                      Compara y contrata el seguro de tu vehículo en un sólo
                      lugar
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      mt: '10px',
                    }}
                  >
                    {policiesData.length < 10 && (
                      <Button
                        variant="contained"
                        onClick={() => newQuote()}
                        size={'medium'}
                        style={{
                          textTransform: 'none',
                          height: '56px',
                          borderRadius: '8px',
                          width: '255px',
                          background: '#1c42e8',
                          gap: '10px',
                        }}
                      >
                        <span
                          style={{
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: '600',
                          }}
                        >
                          Deseo cotizar
                        </span>
                      </Button>
                    )}
                  </Box>
                </Box>
                <Box
                  component={'img'}
                  src={Coppel}
                  sx={{
                    width: { xs: '100%', md: '461px' },
                    height: '406px',
                    mt: 5,
                  }}
                />
              </Box>
            </Grid>
          </Box>

          <Box
            sx={{
              width: { xs: 'auto', md: '655px' },
              padding: { xs: 3, md: 0 },
              display: 'flex',
              flexDirection: 'column',
              height: '550px',
              background: '#FFF',
              borderRadius: '16px',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={{ xs: 2, sm: 52, md: 26 }}
            >
              <Typography
                sx={{
                  fontFamily: 'Montserrat',
                  fontSize: '24px',
                  color: '#212121',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  lineHeight: '28px',
                  textAlign: 'center',
                }}
              >
                Mis pólizas {/*({policiesData.length})*/}
              </Typography>

              <Box
                component={'img'}
                src={Club}
                sx={{ width: { md: '113px' }, height: '40px', mt: 5 }}
              />
            </Stack>
            <Box sx={{ mt: 3 }} />
            <PolicyListSlider items={policiesData} loading={loading} />
          </Box>
        </Stack>
        <Box
          sx={{
            display: 'flex',
            background: '#05297a',
            mt: 5,
            height: '55px',
            borderRadius: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: { xs: '1px', sm: '16px', md: '16px' },
            padding: { xs: '.3em' },
          }}
        >
          <Box
            component={'img'}
            src={Asesor}
            sx={{
              width: { xs: '25px', md: '30px' },
              height: '39px',
              margin: { xs: '12px' },
            }}
          ></Box>
          <Typography
            sx={{
              fontFamily: 'Montserrat',
              fontSize: { xs: 13, sm: 14, md: 20 },
              color: '#FFF',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '20px',
              textAlign: 'center',
            }}
          >
            En caso de siniestro o requerir asistencia vial/legal, comunícate al{' '}
            <b>800-019-6000</b>
          </Typography>
        </Box>
      </Box>
    </div>
  );
};
